module.exports = __webpack_public_path__ + "static/media/emoji-mid-score-2x.36553e60.png";